var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEconomics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Economics",
    transform: "translate(21753 -2570)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4657",
    "data-name": "Rectangle 4657",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21753 2570)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_61",
    "data-name": "Union 61",
    d: "M43.435,46.382H33.1V15.566l4.7-3.229a3.239,3.239,0,0,0,2.614,2.326,2.384,2.384,0,0,0,.58.068,5.18,5.18,0,0,0,2.448-.789V46.381h0Zm-16.08,0H17.019V17.129l.88-.61c.02.037,2.033,3.836,3.965,4.989a1.935,1.935,0,0,0,1,.255c1.794,0,4.053-1.864,4.489-2.237V46.381h0Zm-16.081,0H.938v-20.4a3.088,3.088,0,0,0,.725.364,2.54,2.54,0,0,0,.8.12A3.781,3.781,0,0,0,3.787,26.2l7.479-5.09h.009V46.381h0ZM0,19.833,19.4,6.309l4.772,6.505S35.409,4.653,35.8,4.653,33.319.867,33.319.867L46.371,0S41.2,11.553,41.2,11.671s-2.719-3.706-2.719-3.706L23.3,18.453l-4.533-6.111L2.445,23.46Z",
    transform: "translate(-21731.316 2590.119)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomics);
export default __webpack_public_path__ + "static/media/Economics.e3d059db.svg";
export { ForwardRef as ReactComponent };